var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('CheckoutController', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var formValidationError = _ref.formValidationError,
            newOrder = _ref.newOrder,
            onDataChange = _ref.onDataChange,
            validate = _ref.validate,
            scrollTo = _ref.scrollTo,
            activeIds = _ref.activeIds,
            toggleActive = _ref.toggleActive,
            setActiveList = _ref.setActiveList,
            onLoad = _ref.onLoad,
            onComplete = _ref.onComplete,
            isAllAvailableProductActive = _ref.isAllAvailableProductActive,
            avilableProductIDList = _ref.avilableProductIDList,
            isAvailableBonusesPay = _ref.isAvailableBonusesPay,
            isPrivacyPolicyChecked = _ref.isPrivacyPolicyChecked,
            isShowCallbackCheckbox = _ref.isShowCallbackCheckbox,
            setPrivacyPolicy = _ref.setPrivacyPolicy,
            isPreOrder = _ref.isPreOrder;
        return [_c('UIDataEntity', {
          attrs: {
            "get": _vm.$api.order.getOrderData,
            "params": {
              location: _vm.location,
              activeIds: activeIds
            }
          },
          on: {
            "error": function ($event) {
              return _vm.onLoadOrderData($event);
            },
            "success": function ($event) {
              _vm.onLoadOrderData($event);

              onLoad($event);
            }
          },
          scopedSlots: _vm._u([{
            key: "default",
            fn: function (_ref2) {
              var status = _ref2.status,
                  initialLoad = _ref2.initialLoad,
                  response = _ref2.response,
                  get = _ref2.get;
              return [_c('UIActionEntity', {
                attrs: {
                  "get": _vm.$api.order.create
                },
                on: {
                  "success": function ($event) {
                    _vm.modal = false;

                    _vm.onOrderCreate({
                      order: response,
                      value: newOrder,
                      event: $event,
                      activeIds: activeIds
                    });

                    _vm.$nextTick(function () {
                      return onComplete($event);
                    });
                  },
                  "error": function ($event) {
                    if (_vm.isMobile) {
                      _vm.nextTick(function () {
                        var _vm$mobileErrorNote, _vm$checkoutModal;

                        return scrollTo({
                          el: (_vm$mobileErrorNote = _vm.mobileErrorNote) === null || _vm$mobileErrorNote === void 0 ? void 0 : _vm$mobileErrorNote.$el,
                          boundary: (_vm$checkoutModal = _vm.checkoutModal) === null || _vm$checkoutModal === void 0 ? void 0 : _vm$checkoutModal.$el
                        });
                      });
                    }
                  }
                },
                scopedSlots: _vm._u([{
                  key: "default",
                  fn: function (_ref3) {
                    var _response$product, _newOrder$payment2, _newOrder$payment2$ty, _newOrder$delivery2;

                    var createOrder = _ref3.get,
                        createOrderStatus = _ref3.status,
                        createOrderResponse = _ref3.response;
                    return [status === 'error' && response.error.description !== 'Не добавлены товары в корзину' ? _c('StatusBlock', {
                      attrs: {
                        "content-width": "320px",
                        "size": "l",
                        "type": "error",
                        "title": "Произошла ошибка"
                      }
                    }, [_vm._v("\n        Попробуйте воспользоваться страницей позднее или обновить её\n        "), _c('Button', {
                      staticClass: "mt-15",
                      attrs: {
                        "fluid": "",
                        "size": "39",
                        "theme": "white"
                      },
                      on: {
                        "click": _vm.reload
                      }
                    }, [_vm._v("\n          Обновить страницу\n        ")])], 1) : status === 'loading' && initialLoad ? _c('StatusBlock', {
                      attrs: {
                        "size": "l",
                        "type": "loading",
                        "title": "Идёт загрузка"
                      }
                    }) : status === 'error' && response.error.description === 'Не добавлены товары в корзину' || (response === null || response === void 0 ? void 0 : (_response$product = response.product) === null || _response$product === void 0 ? void 0 : _response$product.length) === 0 ? _c('Unavailable', {
                      attrs: {
                        "icon": "cart"
                      }
                    }, [_c('div', {
                      staticClass: "h5 mb-8"
                    }, [_vm._v("\n          В корзине нет товаров\n        ")]), _vm._v(" "), _c('div', {
                      staticClass: "p"
                    }, [_vm._v("\n          Добавить товары в корзину можно через "), _c('nuxt-link', {
                      staticClass: "link",
                      attrs: {
                        "to": "/catalog/"
                      }
                    }, [_vm._v("\n            каталог\n          ")]), _vm._v(" или страницу товара.\n        ")], 1)]) : status === 'success' || !initialLoad ? _c('div', {
                      staticClass: "checkout__wrap",
                      class: {
                        checkout__wrap_loading: status === 'loading'
                      }
                    }, [_c('div', {
                      staticClass: "checkout__loading-block"
                    }), _vm._v(" "), _c('Modal', {
                      ref: "checkoutModal",
                      attrs: {
                        "mobile-fullscreen": "",
                        "show": _vm.modal,
                        "title": "Оформление заказа"
                      },
                      on: {
                        "close": function () {
                          return _vm.modal = false;
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "title",
                        fn: function () {
                          return [_c('div', {
                            staticClass: "checkout__wrap-mobile-title"
                          }, [_vm._v("\n              Оформление заказа\n            ")])];
                        },
                        proxy: true
                      }], null, true)
                    }, [_vm._v(" "), _c('StepController', {
                      staticClass: "mobile-checkout",
                      attrs: {
                        "data-e2e": "step-controller",
                        "list": _vm.controllerNavigation
                      },
                      on: {
                        "complete": function ($event) {
                          _vm.modal = false;
                        },
                        "next-step": _vm.yandexMetrickaNextStep,
                        "close": function ($event) {
                          _vm.modal = false;
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "contact",
                        fn: function (_ref4) {
                          var next = _ref4.next;
                          return [_c('ValidationObserver', {
                            ref: "mobileContactStep"
                          }, [_c('StepContact', {
                            attrs: {
                              "contact": newOrder === null || newOrder === void 0 ? void 0 : newOrder.contact
                            },
                            on: {
                              "change-data": function ($event) {
                                return onDataChange('contact', $event);
                              }
                            }
                          }), _vm._v(" "), _c('div', {
                            staticClass: "checkout__button checkout__button_mobile"
                          }, [_c('Button', {
                            attrs: {
                              "data-e2e": "to-second-step",
                              "theme": "red",
                              "icon": "arrow-right",
                              "icon-position": "right",
                              "border-radius": "0",
                              "size": "49",
                              "fluid": ""
                            },
                            on: {
                              "click": function ($event) {
                                validate({
                                  observer: _vm.mobileContactStep,
                                  boundary: _vm.checkoutModal,

                                  onSuccess: function onSuccess() {
                                    next();
                                  }

                                });
                              }
                            }
                          }, [_vm._v("\n                    Продолжить\n                  ")])], 1)], 1)];
                        }
                      }, {
                        key: "delivery",
                        fn: function (_ref5) {
                          var next = _ref5.next;
                          return [_c('ValidationObserver', {
                            ref: "mobileDeliveryStep"
                          }, [_c('UIActionEntity', {
                            attrs: {
                              "get": _vm.$api.location.setCityCurrent
                            },
                            on: {
                              "error": function ($event) {
                                new _vm.$simpleError({
                                  message: 'Ошибка при смене города'
                                });
                              },
                              "success": function ($event) {
                                if (_vm.newCity) {
                                  _vm.setCurrentCity(_vm.newCity);
                                }

                                _vm.$nextTick(function () {
                                  get();
                                });
                              }
                            },
                            scopedSlots: _vm._u([{
                              key: "default",
                              fn: function (_ref6) {
                                var request = _ref6.get;
                                return [_vm.city ? _c('StepDelivery', {
                                  attrs: {
                                    "list": response.delivery,
                                    "city": _vm.city,
                                    "value": newOrder.delivery,
                                    "delivery-date": response.deliveryIntervals
                                  },
                                  on: {
                                    "change": function ($event) {
                                      return onDataChange('delivery', $event);
                                    },
                                    "city-change": function ($event) {
                                      request($event);
                                      _vm.newCity = Object.assign({}, $event);
                                    }
                                  }
                                }) : _vm._e()];
                              }
                            }], null, true)
                          }), _vm._v(" "), _c('div', {
                            staticClass: "checkout__button checkout__button_mobile"
                          }, [_c('Button', {
                            attrs: {
                              "data-e2e": "to-third-step",
                              "theme": "red",
                              "icon": "arrow-right",
                              "icon-position": "right",
                              "border-radius": "0",
                              "size": "49",
                              "fluid": ""
                            },
                            on: {
                              "click": function ($event) {
                                validate({
                                  observer: _vm.mobileDeliveryStep,
                                  boundary: _vm.checkoutModal,

                                  onSuccess: function onSuccess() {
                                    next();
                                  }

                                });
                              }
                            }
                          }, [_vm._v("\n                    Продолжить\n                  ")])], 1)], 1)];
                        }
                      }, {
                        key: "payment",
                        fn: function (_ref7) {
                          var _newOrder$payment, _newOrder$payment$typ;

                          var next = _ref7.next;
                          return [_c('ValidationObserver', {
                            ref: "mobilePaymentStep"
                          }, [_c('StepPayment', {
                            attrs: {
                              "list": response.payment,
                              "value": newOrder === null || newOrder === void 0 ? void 0 : (_newOrder$payment = newOrder.payment) === null || _newOrder$payment === void 0 ? void 0 : (_newOrder$payment$typ = _newOrder$payment.type) === null || _newOrder$payment$typ === void 0 ? void 0 : _newOrder$payment$typ.id
                            },
                            on: {
                              "change": function ($event) {
                                return onDataChange('payment', $event);
                              }
                            }
                          }), _vm._v(" "), _c('div', {
                            staticClass: "checkout__button checkout__button_mobile"
                          }, [_c('Button', {
                            attrs: {
                              "data-e2e": "to-fourth-step",
                              "theme": "red",
                              "icon": "arrow-right",
                              "icon-position": "right",
                              "border-radius": "0",
                              "size": "49",
                              "fluid": ""
                            },
                            on: {
                              "click": function ($event) {
                                validate({
                                  observer: _vm.mobilePaymentStep,
                                  boundary: _vm.checkoutModal,

                                  onSuccess: function onSuccess() {
                                    next();
                                  }

                                });
                              }
                            }
                          }, [_vm._v("\n                    Продолжить\n                  ")])], 1)], 1)];
                        }
                      }, {
                        key: "summary",
                        fn: function () {
                          var _newOrder$delivery;

                          return [_c('ValidationObserver', {
                            ref: "mobileSummaryStep"
                          }, [_c('OrderSummaryMobile', {
                            attrs: {
                              "active-ids": activeIds,
                              "product-link": false,
                              "order": response,
                              "value": newOrder,
                              "city": _vm.city
                            }
                          }), _vm._v(" "), _c('Summary', {
                            staticClass: "mt-25",
                            attrs: {
                              "delivery": newOrder === null || newOrder === void 0 ? void 0 : (_newOrder$delivery = newOrder.delivery) === null || _newOrder$delivery === void 0 ? void 0 : _newOrder$delivery.type,
                              "value": newOrder,
                              "total": response.total,
                              "coupon-list": response.coupon,
                              "errors": formValidationError || undefined,
                              "loading": createOrderStatus === 'loading',
                              "button": false,
                              "is-unavailable-exist": response.isUnavailableExist,
                              "is-privacy-policy-checked": isPrivacyPolicyChecked,
                              "is-show-callback-checkbox": isShowCallbackCheckbox,
                              "is-pre-order": isPreOrder
                            },
                            on: {
                              "change-data": function ($event) {
                                return onDataChange('summary', $event);
                              },
                              "coupon-change": get,
                              "privacy-policy-status-update": function ($event) {
                                return setPrivacyPolicy($event);
                              }
                            }
                          }), _vm._v(" "), createOrderStatus === 'error' ? _c('ErrorNote', {
                            ref: "mobileErrorNote",
                            staticClass: "mt-15",
                            attrs: {
                              "error": createOrderResponse
                            }
                          }) : _vm._e(), _vm._v(" "), _c('div', {
                            staticClass: "checkout__button checkout__button_mobile"
                          }, [_c('Button', {
                            attrs: {
                              "data-e2e": "checkout-mobile",
                              "theme": "red",
                              "disabled": !isPrivacyPolicyChecked,
                              "loading": createOrderStatus === 'loading',
                              "border-radius": "0",
                              "size": "49",
                              "fluid": ""
                            },
                            on: {
                              "click": function () {
                                validate({
                                  observer: _vm.mobileSummaryStep,
                                  boundary: _vm.checkoutModal,

                                  onSuccess: function onSuccess() {
                                    createOrder(newOrder);

                                    _vm.onChangeCart(false);
                                  }

                                });
                              }
                            }
                          }, [_vm._v("\n                    Оформить заказ\n                  ")])], 1)], 1)];
                        },
                        proxy: true
                      }], null, true)
                    })], 1), _vm._v(" "), _c('div', {
                      staticClass: "checkout__left-side"
                    }, [_c('div', {
                      staticClass: "checkout__product-list"
                    }, [_c('h1', {
                      staticClass: "checkout__title"
                    }, [_vm._v("\n              В корзине " + _vm._s(_vm.formatQuantity(_vm.cartCount)) + "\n            ")]), _vm._v(" "), _c('UIActionEntity', {
                      attrs: {
                        "get": _vm.$api.cart.removeProducts
                      },
                      on: {
                        "error": _vm.onErrorRemoveProducts,
                        "success": function ($event) {
                          return _vm.onSuccessRemoveProducts(activeIds);
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "default",
                        fn: function (_ref8) {
                          var _response$product2;

                          var removeActiveProducts = _ref8.get;
                          return [_c('div', [response !== null && response !== void 0 && (_response$product2 = response.product) !== null && _response$product2 !== void 0 && _response$product2.length ? _c('div', {
                            staticClass: "checkout__select-all"
                          }, [_c('Checkbox', {
                            attrs: {
                              "checked": isAllAvailableProductActive
                            },
                            on: {
                              "change": function ($event) {
                                // @ts-ignore
                                setActiveList($event ? avilableProductIDList : [], {
                                  onComplete: get
                                });
                              }
                            }
                          }, [_vm._v("\n                    Выбрать все\n                  ")]), _vm._v(" "), _c('div', {
                            staticClass: "grey-text",
                            on: {
                              "click": function ($event) {
                                return removeActiveProducts({
                                  productArray: activeIds
                                });
                              }
                            }
                          }, [_vm._v("\n                    Удалить "), _c('span', {
                            staticClass: "hide-on-mobile"
                          }, [_vm._v("выбранные")]), _vm._v(" (" + _vm._s(activeIds.length) + ")\n                  ")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
                            staticClass: "checkout__els"
                          }, [_c('CartProductList', {
                            attrs: {
                              "products": response.product
                            },
                            on: {
                              "check": function ($event) {
                                // @ts-ignore
                                toggleActive($event, {
                                  onComplete: get
                                });
                              },
                              "update": function ($event) {
                                _vm.$nextTick(function () {
                                  return get();
                                });
                              },
                              "remove-unavailables": function ($event) {
                                return removeActiveProducts({
                                  productArray: $event
                                });
                              }
                            }
                          })], 1)])];
                        }
                      }], null, true)
                    })], 1), _vm._v(" "), _c('div', {
                      staticClass: "checkout__step"
                    }, [_c('h2', {
                      staticClass: "h2 mb-18"
                    }, [_vm._v("\n              Данные для связи\n            ")]), _vm._v(" "), _c('StepContact', {
                      attrs: {
                        "contact": newOrder === null || newOrder === void 0 ? void 0 : newOrder.contact
                      },
                      on: {
                        "change-data": function ($event) {
                          return onDataChange('contact', $event);
                        }
                      }
                    })], 1), _vm._v(" "), _c('div', {
                      staticClass: "checkout__step"
                    }, [_c('h2', {
                      staticClass: "h2 mb-18"
                    }, [_vm._v("\n              Доставка\n            ")]), _vm._v(" "), _c('UIActionEntity', {
                      attrs: {
                        "get": _vm.$api.location.setCityCurrent
                      },
                      on: {
                        "error": function ($event) {
                          new _vm.$simpleError({
                            message: 'Ошибка при смене города'
                          });
                        },
                        "success": function ($event) {
                          if (_vm.newCity) {
                            _vm.setCurrentCity(_vm.newCity);
                          }

                          _vm.$nextTick(function () {
                            get();
                          });
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "default",
                        fn: function (_ref9) {
                          var request = _ref9.get;
                          return [_vm.city ? _c('StepDelivery', {
                            attrs: {
                              "list": response.delivery,
                              "city": _vm.city,
                              "value": newOrder === null || newOrder === void 0 ? void 0 : newOrder.delivery,
                              "delivery-date": response.deliveryIntervals
                            },
                            on: {
                              "change": function ($event) {
                                return onDataChange('delivery', $event);
                              },
                              "city-change": function ($event) {
                                request($event);
                                _vm.newCity = Object.assign({}, $event);
                              }
                            }
                          }) : _vm._e()];
                        }
                      }], null, true)
                    })], 1), _vm._v(" "), _c('div', {
                      staticClass: "checkout__step"
                    }, [_c('h2', {
                      staticClass: "h2 mb-18"
                    }, [_vm._v("\n              Оплата\n            ")]), _vm._v(" "), _c('StepPayment', {
                      attrs: {
                        "list": response.payment,
                        "value": newOrder === null || newOrder === void 0 ? void 0 : (_newOrder$payment2 = newOrder.payment) === null || _newOrder$payment2 === void 0 ? void 0 : (_newOrder$payment2$ty = _newOrder$payment2.type) === null || _newOrder$payment2$ty === void 0 ? void 0 : _newOrder$payment2$ty.id
                      },
                      on: {
                        "change": function ($event) {
                          return onDataChange('payment', $event);
                        }
                      }
                    })], 1), _vm._v(" "), _c('client-only', [_c('div', {
                      staticClass: "checkout-accessories"
                    }, [_c('UIDataEntity', {
                      attrs: {
                        "get": _vm.$api.cart.getAccessories
                      },
                      on: {
                        "success": function ($event) {
                          onLoad($event);

                          _vm.$nextTick(function () {
                            return get();
                          });
                        }
                      },
                      scopedSlots: _vm._u([{
                        key: "default",
                        fn: function (_ref10) {
                          var _response$result;

                          var response = _ref10.response,
                              success = _ref10.success;
                          return [success && (_response$result = response.result) !== null && _response$result !== void 0 && _response$result.length ? _c('div', [_c('h3', {
                            staticClass: "checkout-accessories__title"
                          }, [_vm._v("\n                    Может пригодиться\n                  ")]), _vm._v(" "), _c('div', {
                            staticClass: "catalog-root__slider"
                          }, [_c('RowSliderNew', {
                            attrs: {
                              "list": response === null || response === void 0 ? void 0 : response.result,
                              "offset-between-elements": 10
                            },
                            scopedSlots: _vm._u([{
                              key: "default",
                              fn: function (_ref11) {
                                var el = _ref11.el;
                                return [_c('AccessoriesProductCard', {
                                  staticClass: "checkout-accessories-card",
                                  attrs: {
                                    "product": el,
                                    "source": "Может пригодиться"
                                  },
                                  on: {
                                    "add-product": function ($event) {
                                      return _vm.$emitter.emit('add-to-cart-accessory', {
                                        product: el,
                                        type: 'card'
                                      });
                                    },
                                    "product-select": function ($event) {
                                      var _el$title;

                                      return _vm.$emitter.emit('product-select', {
                                        product: el,
                                        listName: (_el$title = el.title) !== null && _el$title !== void 0 ? _el$title : ''
                                      });
                                    }
                                  }
                                })];
                              }
                            }], null, true)
                          })], 1)]) : _vm._e()];
                        }
                      }], null, true)
                    })], 1)])], 1), _vm._v(" "), _c('div', {
                      staticClass: "checkout__right-side"
                    }, [_vm.isGuest ? _c('InfoBonus', {
                      attrs: {
                        "quantity": response.total.bonus.income
                      }
                    }) : _vm._e(), _vm._v(" "), _c('div', {
                      staticClass: "checkout__right-side-content"
                    }, [_c('Summary', {
                      attrs: {
                        "delivery": newOrder === null || newOrder === void 0 ? void 0 : (_newOrder$delivery2 = newOrder.delivery) === null || _newOrder$delivery2 === void 0 ? void 0 : _newOrder$delivery2.type,
                        "value": newOrder,
                        "is-available-bonuses-pay": isAvailableBonusesPay,
                        "total": response.total,
                        "coupon-list": response.coupon,
                        "is-pre-order": isPreOrder,
                        "errors": formValidationError || undefined,
                        "loading": createOrderStatus === 'loading',
                        "api-error": createOrderStatus === 'error' ? createOrderResponse : false,
                        "is-unavailable-exist": response.isUnavailableExist,
                        "hide-comment-field-on-mobile": true,
                        "is-show-callback-checkbox": isShowCallbackCheckbox,
                        "is-privacy-policy-checked": isPrivacyPolicyChecked,
                        "hide-privacy-policy-on-mobile": ""
                      },
                      on: {
                        "privacy-policy-status-update": function ($event) {
                          return setPrivacyPolicy($event);
                        },
                        "change-data": function ($event) {
                          return onDataChange('summary', $event);
                        },
                        "coupon-change": get,
                        "promocode-status": function ($event) {
                          var _response$total$price;

                          return _vm.emitter.emit('apply-promocode', {
                            status: $event,
                            discount: (_response$total$price = response.total.price) === null || _response$total$price === void 0 ? void 0 : _response$total$price.discount
                          });
                        },
                        "checkout": function ($event) {
                          _vm.isMobile ? _vm.enableModal() : validate({
                            onSuccess: function onSuccess() {
                              createOrder(newOrder);
                            }

                          });
                        }
                      }
                    })], 1)], 1)], 1) : _vm._e()];
                  }
                }], null, true)
              })];
            }
          }], null, true)
        })];
      }
    }])
  });
}
var staticRenderFns = []

export { render, staticRenderFns }